class CartAPI {
  static listeners = [];

  static subscribe(callback) {
    this.listeners.push(callback);
  }

  static notify(state) {
    this.listeners.forEach(callback => callback(state));
  }

  static async changeLineItem(line, quantity, sections = ['cart-drawer', 'cart-icon-bubble']) {
    const body = JSON.stringify({ line, quantity, sections, sections_url: window.location.pathname });
    return this.performCartRequest(`${window.Shopify.routes.root}cart/change.js`, body);
  }

  static async addLineItem(id, quantity = 1, properties = {}, sections = ['cart-drawer', 'cart-icon-bubble']) {
    const body = JSON.stringify({ id, quantity, properties, sections, sections_url: window.location.pathname });
    return this.performCartRequest(`${window.Shopify.routes.root}cart/add.js`, body);
  }

  // Saves the cart note. Called with no sections by default: a note edit changes no visible
  // totals or counts, so there is nothing to re-render, and skipping sections avoids replacing
  // the textarea the shopper just typed into.
  static async updateNote(note, sections = []) {
    const payload = { note };
    if (sections.length > 0) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }
    return this.performCartRequest(`${window.Shopify.routes.root}cart/update.js`, JSON.stringify(payload));
  }

  static async addFromForm(form, sections = ['cart-drawer', 'cart-icon-bubble']) {
    const formData = new FormData(form);
    
    sections.forEach(section => {
      formData.append('sections[]', section);
    });
    formData.append('sections_url', window.location.pathname);

    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Accept': 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      });
      const state = await response.json();
      
      if (state.status) {
        throw state;
      }
      
      this.notify(state);
      return state;
    } catch (error) {
      console.error('Cart API Form Error:', error);
      throw error;
    }
  }

  static async performCartRequest(url, body) {
    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body
      });
      const state = await response.json();
      
      if (state.status) {
        throw state;
      }
      
      this.notify(state);
      return state;
    } catch (error) {
      console.error('Cart API Error:', error);
      throw error;
    }
  }
}

window.CartAPI = CartAPI;